export default "__VITE_ASSET__DNcp1prB__"